const CATEGORIES = require('./nationalAccessibility');

const CITIZENSHIP = {
  RU: 'ru',
  AM: 'am',
  BY: 'by',
  KZ: 'kz',
  KG: 'kg',
  OTHER: 'other',
};

const CITIZENSHIP_CATEGORY = {
  [CATEGORIES.RUS]: [CITIZENSHIP.RU],
  [CATEGORIES.OTHER]: [CITIZENSHIP.OTHER],
  [CATEGORIES.EAEU]: [
    CITIZENSHIP.AM,
    CITIZENSHIP.BY,
    CITIZENSHIP.KZ,
    CITIZENSHIP.KG,
  ],
};

module.exports = {
  CITIZENSHIP,
  CITIZENSHIP_CATEGORY,
};
